module.exports = __webpack_public_path__ + "static/media/spot25.3936cce4.webp";